const path = process.env.PUBLIC_URL

function Cover() {
  return (
    <div className='cover'>
      <div className="cover__wrapper">
        <div className='cover__title'>
          <h1>The Run movement:</h1>
        </div>
        <div className='cover__title'>
          <h1>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Why are</h1>
        </div>
        <div className='cover__title'>
          <h1>so many people</h1>
        </div>
        <div className='cover__title'>
          <h1>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fleeing China?</h1>
          <h1>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fleeing China?</h1>
        </div>
        <img src={`${path}/icon0.png`} className="icon icon0" />
        <img src={`${path}/icon1.png`} className="icon icon1" />
        <img src={`${path}/icon2.png`} className="icon icon2" />
        <img src={`${path}/icon3.png`} className="icon icon3" />
      </div>
      <div className="cover__box">
        <div className="cover__tag">WHYNOT Special Report</div>
        <div className="cover__date">07 / 07 / 2023</div>
      </div>
    </div>
  );
}

export default Cover;